var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiguremindandbody(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 25.2276 21.7148",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 21.7148,
    opacity: 0,
    width: 25.2276,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.391126 9.89062L4.31691 13.8281C4.85597 14.3672 5.73488 14.3789 6.26222 13.7227L8.73488 10.6758C8.89894 10.4883 9.15675 10.5938 9.15675 10.8281L9.15675 16.0195L4.72706 15.5273C3.20363 15.3516 2.71144 17.5898 4.17628 18.0703L9.20363 19.7344C8.95753 20.7773 9.85988 21.668 10.8911 21.3281L12.438 20.8242L13.9849 21.3281C15.0161 21.668 15.9185 20.7773 15.6724 19.7344L20.7114 18.0703C22.1763 17.5898 21.6724 15.3516 20.1489 15.5273L15.7193 16.0195L15.7193 10.8281C15.7193 10.5938 15.9888 10.4883 16.1411 10.6758L18.6138 13.7227C19.1411 14.3789 20.02 14.3672 20.5591 13.8281L24.4849 9.89062C25.0005 9.36328 25.0122 8.55469 24.4849 8.03906C23.981 7.53516 23.1489 7.53516 22.6333 8.03906L19.7388 10.9453L16.7857 7.32422C16.2935 6.72656 15.5552 6.35156 14.77 6.35156L10.1177 6.35156C9.32081 6.35156 8.59425 6.72656 8.09034 7.32422L5.13722 10.9453L2.24269 8.03906C1.72706 7.53516 0.895032 7.53516 0.391126 8.03906C-0.136218 8.55469-0.124499 9.36328 0.391126 9.89062ZM12.438 5.12109C13.8443 5.12109 14.981 3.97266 14.981 2.54297C14.981 1.13672 13.8443 0 12.438 0C11.0083 0 9.85988 1.13672 9.85988 2.54297C9.85988 3.97266 11.0083 5.12109 12.438 5.12109Z",
    fill: "currentColor",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiguremindandbody);
export default __webpack_public_path__ + "static/media/figure.mind.and.body.1d07f2b2e0cf09aedc0011cee81c8202.svg";
export { ForwardRef as ReactComponent };